import { toastMessage } from '../store.js';

export default function Toast() {
  const t = toastMessage.value;
  const typeClass = t?.type === 'error' ? ' etm-toast--error' : t?.type === 'success' ? ' etm-toast--success' : '';
  return (
    <div class={`etm-toast${t ? ' visible' : ''}${typeClass}`} role="status" aria-live="polite">
      {t?.text}
    </div>
  );
}
